/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * InstaLaw Forms API
 * OpenAPI spec version: 0.0.1
 */
import { customInstance } from '../custom-mutator';
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FormFieldType = {
    text: 'text',
    textarea: 'textarea',
    email: 'email',
    phone: 'phone',
    number: 'number',
    date: 'date',
    select: 'select',
    checkbox: 'checkbox',
    radio: 'radio',
    file: 'file',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileStatusStatus = {
    pending_scan: 'pending_scan',
    clean: 'clean',
    infected: 'infected',
    quarantined: 'quarantined',
};
export const getGetFormConfigBySlugUrl = (org, slug) => {
    return `/api/form-config/${org}/${slug}`;
};
export const getFormConfigBySlug = async (org, slug, options) => {
    return customInstance(getGetFormConfigBySlugUrl(org, slug), {
        ...options,
        method: 'GET'
    });
};
export const getPresignUploadUrl = (org, slug) => {
    return `/api/forms/${org}/${slug}/presign`;
};
export const presignUpload = async (org, slug, presignRequest, options) => {
    return customInstance(getPresignUploadUrl(org, slug), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(presignRequest)
    });
};
export const getSubmitFormBySlugUrl = (org, slug) => {
    return `/api/forms/${org}/${slug}/submit`;
};
export const submitFormBySlug = async (org, slug, submitFormBody, options) => {
    return customInstance(getSubmitFormBySlugUrl(org, slug), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(submitFormBody)
    });
};
export const getGetFileStatusUrl = (id) => {
    return `/api/files/${id}/status`;
};
export const getFileStatus = async (id, options) => {
    return customInstance(getGetFileStatusUrl(id), {
        ...options,
        method: 'GET'
    });
};
export const getS3GuardDutyEventsUrl = () => {
    return `/internal/s3/events`;
};
export const s3GuardDutyEvents = async (s3GuardDutyEventsBody, options) => {
    return customInstance(getS3GuardDutyEventsUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(s3GuardDutyEventsBody)
    });
};
export const getCreateFormUrl = () => {
    return `/api/attorneys/forms`;
};
export const createForm = async (createFormRequest, options) => {
    return customInstance(getCreateFormUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(createFormRequest)
    });
};
export const getGetFormByIdUrl = (id) => {
    return `/api/attorneys/forms/${id}`;
};
export const getFormById = async (id, options) => {
    return customInstance(getGetFormByIdUrl(id), {
        ...options,
        method: 'GET'
    });
};
export const getListResponsesUrl = (org, slug, params) => {
    const normalizedParams = new URLSearchParams();
    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });
    const stringifiedParams = normalizedParams.toString();
    return stringifiedParams.length > 0 ? `/api/attorneys/forms/${org}/${slug}/responses?${stringifiedParams}` : `/api/attorneys/forms/${org}/${slug}/responses`;
};
export const listResponses = async (org, slug, params, options) => {
    return customInstance(getListResponsesUrl(org, slug, params), {
        ...options,
        method: 'GET'
    });
};
export const getGetPortalUrl = (org, portalId) => {
    return `/api/portals/${org}/${portalId}`;
};
export const getPortal = async (org, portalId, options) => {
    return customInstance(getGetPortalUrl(org, portalId), {
        ...options,
        method: 'GET'
    });
};
export const getListPortalPagesUrl = (org, portalId) => {
    return `/api/portals/${org}/${portalId}/pages`;
};
export const listPortalPages = async (org, portalId, options) => {
    return customInstance(getListPortalPagesUrl(org, portalId), {
        ...options,
        method: 'GET'
    });
};
